<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-2">
        <BaseCheckbox
          label="Dengan Stok Kosong"
          v-model="filter.withEmptyStock"
        />
        <base-select
          :options="[
            { key: 'null', label: 'Semua', value: null },
            {
              key: 'pusat',
              label: 'Pusat',
              value: 'pusat',
            },
            {
              key: 'kantor_pelayanan',
              label: 'Kantor Pelayanan',
              value: 'kantor_pelayanan',
            },
            {
              key: 'stockist_center',
              label: 'Stockist Center',
              value: 'stockist_center',
            },
            { key: 'stockist', label: 'Stockist', value: 'stockist' },
          ]"
          :shadow="false"
          v-model="filter.officeType"
        />
        <OfficeSelectSearch
          ref="filterOffice"
          :shadow="false"
          :request-params="{
            'filter[in-office_category_id]': filterOfficeCategoryId,
          }"
          v-model="filter.office"
        />
        <base-button
          :loading="loadingProcess.visible"
          @click="onProcess"
          >{{
            loadingProcess.visible ? loadingProcessLabel : 'Export'
          }}</base-button
        >
      </div>
      <Datatable
        :total="histories.meta.page.total"
        :perPage="histories.meta.page.perPage"
        :currentPage="histories.meta.page.currentPage"
        :columns="[
          { id: 'date', name: 'Tanggal' },
          { id: 'user', name: 'User' },
          { id: 'status', name: 'Status', theadClass: 'text-center' },
          {
            id: 'download',
            name: 'Download Export',
            theadClass: 'text-center',
          },
        ]"
        @pagechanged="onChangeHistoryPage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="history in histories.data"
            :key="history.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">
              {{ history.attributes.createdAt | formatDate }}
            </td>
            <td :class="classes.td">{{ history.attributes.user_email }}</td>
            <td :class="[classes.td, 'text-center']">
              <BaseBadge v-if="!history.attributes.finishedAt" color="yellow"
                >Sedang Diproses</BaseBadge
              >
              <BaseBadge v-else color="green">Selesai</BaseBadge>
            </td>
            <td :class="[classes.td, 'text-center']">
              <a
                v-if="history.attributes.file_url"
                :href="history.attributes.file_url"
                class="flex justify-center text-green-600"
              >
                <Icon icon="heroicons:arrow-down-tray" class="h-4 w-4" />
              </a>
            </td>
          </tr>
        </template>
      </Datatable>
    </div>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapGetters, mapActions } from 'vuex';
import OfficeSelectSearch from '../../../../components/office/office-select-search.vue';
import BaseCheckbox from '../../../../components/base/BaseCheckbox.vue';

export default {
  mixins: [requestMixin],
  components: {
    OfficeSelectSearch,
    BaseCheckbox,
  },
  data() {
    return {
      filter: {
        officeType: null,
        office: null,
        withEmptyStock: true,
      },
      loadingHistories: false,
      loadingProcess: {
        visible: false,
        text: null,
      },
      histories: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    filterOfficeCategoryId() {
      if (!this.filter.officeType) {
        return '1,2,3,4';
      }

      return {
        pusat: 1,
        kantor_pelayanan: 2,
        stockist_center: 3,
        stockist: 4,
      }[this.filter.officeType];
    },
    loading() {
      return this.loadingHistories;
    },
    loadingProcessLabel() {
      return {
        wait: 'Mengirim Data',
        queued: 'Menunggu Diproses',
        processing: 'Sedang Diproses',
      }[this.loadingProcess.text];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onProgress
      );
    },
    async loadExportHistories(params) {
      this.loadingHistories = true;

      const [res, err] = await this.request(
        '/api/v1/office-type-stock-exports',
        {
          params: {
            'page[size]': 5,
            sort: '-id',
            'filter[export_type]': 'single',
            ...params,
          },
        }
      );

      if (!err) {
        const running = res.data.some(
          (history) => !history.attributes.finishedAt
        );

        if (running) {
          this.startLoadingProcess('processing');
        }

        this.histories = res;
      }

      this.loadingHistories = false;
    },
    onProgress(e) {
      if (e.type === 'App\\Notifications\\OfficeTypeStockExported' && e.export_type === 'single') {
        this.stopLoadingProcess();

        this.createAlert({
          status: 'success',
          data: 'Berhasil mengexport stock',
        });

        this.loadExportHistories();
      }
    },
    async onChangeOfficeType() {
      await this.$nextTick();

      this.$refs.filterOffice.loadOffices();
    },
    onChangeHistoryPage(page) {
      this.loadExportHistories({
        'page[number]': page,
      });
    },
    async onProcess() {
      this.startLoadingProcess('wait');

      const [, err] = await this.request(
        '/api/v1/office-type-stock-exports/-actions/export',
        {
          method: 'post',
          data: {
            office_type: this.filter.officeType,
            office_id: this.filter.office?.attributes?.office_id,
            with_empty_stock: this.filter.withEmptyStock,
          },
        }
      );

      if (!err) {
        this.startLoadingProcess('processing');
      } else {
        this.stopLoadingProcess();
      }
    },
    removeListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onProgress
        );
      }
    },
    startLoadingProcess(text) {
      this.loadingProcess.text = text;
      this.loadingProcess.visible = true;
    },
    stopLoadingProcess() {
      this.loadingProcess.visible = false;
    },
  },
  created() {
    this.loadExportHistories();
    this.addListener();
  },
  beforeRouteLeave(to, from, next) {
    this.removeListener();
    next();
  },
};
</script>
